import WaitlistForm from "./WaitlistForm";

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-28 md:py-36 border-t border-white/[0.06] overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg pointer-events-none" aria-hidden="true" />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[420px] w-[720px] rounded-full bg-indigo-600/15 blur-[130px] pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-3xl border border-white/[0.08] bg-[#0A0A0A]/80 backdrop-blur-xl p-10 md:p-16 text-center">
          <div className="absolute -inset-px rounded-3xl bg-gradient-to-br from-indigo-500/25 via-transparent to-violet-500/25 -z-10 blur-xl" />
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">
            <span className="h-1.5 w-1.5 rounded-full bg-indigo-400 shadow-[0_0_10px_rgba(99,102,241,0.9)]" />
            <span className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-400">
              Join Early Access
            </span>
          </div>

          <h2 className="mt-6 font-display font-semibold tracking-tighter text-white text-3xl md:text-5xl text-balance">
            Be first to try a more{" "}
            <span className="bg-gradient-to-r from-indigo-300 via-violet-300 to-sky-300 bg-clip-text text-transparent">
              equal
            </span>{" "}
            web.
          </h2>
          <p className="mt-5 font-body text-zinc-400 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            We're opening access in small waves. Join now and help shape EqualLayer into a standard that
            works for everyone.
          </p>

          <div className="mx-auto mt-10 max-w-xl">
            <WaitlistForm variant="final" />
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500">
            <span>No spam</span>
            <span className="h-1 w-1 rounded-full bg-zinc-700" />
            <span>Unsubscribe anytime</span>
            <span className="h-1 w-1 rounded-full bg-zinc-700" />
            <span>Built in the open</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
